export default Object.freeze({
  list: [],
  tags: {},
  selected: null,
});
